export default {
  actions: [
    'SEED/POTENTIAL',
    'RELEASING',
    'REORGANIZING',
    'REVALUING',
    'UNDERSTANDING',
    'SHARING',
    'REALIZING',
    'IMPROVING',
    'EXPRESSING',
    'DECIDING',
    'ORGANIZING',
    'FOCUSING',
  ],
  genders: [
    'Feminine',
    'Masculine',
    'Feminine',
    'Masculine',
    'Feminine',
    'Masculine',
    'Feminine',
    'Masculine',
    'Feminine',
    'Masculine',
    'Feminine',
    'Masculine',
  ],
  elements: [
    'MUTABLE WATER',
    'FIXED AIR',
    'CARDINAL EARTH',
    'MUTABLE FIRE',
    'FIXED WATER',
    'CARDINAL AIR',
    'MUTABLE EARTH',
    'FIXED FIRE',
    'CARDINAL WATER',
    'MUTABLE AIR',
    'FIXED EARTH',
    'CARDINAL FIRE',
  ],
  qualities: [
    'vicissitudes',
    'self-sacrifice',
    'verity',
    'repression',
    'inspiration',
    'originality',
    'idealism',
    'martyrdom',
    'organization',
    'illumination',
    'exploration',
    'devotion',
    'attainment', // very unreadable
    'responsibility',
    'resourcefulness',
    'expiation',
    'independence',
    'policy',
    'presagition', // almost certainly not, but sounds good
    'experience',
    'achievement',
    'ambition',
    'reformation',
    'rulership',
    'research',
    'revelation',
    'moods', // entirely unreadable
    'reason',
    'fidelity',
    'intuition',
    'mastership',
    'struggle',
    'determination',
    'pragmatism', // very unreadable
    'tradition', // also almost certainly wrong
    'activity',
  ],

  zodiacSymbols: ['♓', '♒', '♑', '♐', '♏', '♎', '♍', '♌', '♋', '♊', '♉', '♈'],

  zodiacThemes: [
    'Endings',
    'Goals and Ideals',
    'Mount Meru',
    'Higher Mind',
    'Death and Rebirth',
    'Relationships',
    'Health and Service',
    'Creative Expression',
    'Foundations',
    'Lower Mind',
    'Materiality',
    'New Beginnings',
  ],

  quadrantBig: ['PHYSICAL', 'SPIRITUAL', 'MENTAL', 'EMOTIONAL'],

  quadrantSmall: ['DIFFERENTIATION', 'UNITY', 'INTEGRATION', 'INDIVIDUATION'],

  hemispheres: ['CONJUNCTION', 'OPPOSITION'],
  squares: ['SQUARE', 'SQUARE'],
  semisquares: ['SEMISQUARE', 'SESQUIQUADRATE', 'SESQUIQUADRATE', 'SEMISQUARE'],
  trines: ['', 'TRINE', 'TRINE'],
  sextiles: ['', 'SEMISEXTILE', 'SEXTILE', '', '', 'INCONJUNCT', '', 'INCONJUNCT', '', '', 'SEXTILE', 'SEMISEXTILE'],

  planets: ['♇', '♆', '⛢', '♄', '♃', '♂', '♁', '♀', '☿'],
};
